/**
 * Feature flags — flip these to gate incomplete or paused features.
 * Backend routes are kept live even when the frontend is hidden, so we can
 * re-enable in a single line change without a backend redeploy.
 */
export const FEATURES = {
  // Stripe checkout, plans, subscription upgrade UI. Backend APIs remain live
  // for future re-enable. Keep off — Razorpay is the active gateway.
  STRIPE_UI: false,
  // Razorpay Standard Checkout. Exposes Plans menu entry + Razorpay-only
  // payment buttons in the checkout dialog. Backend endpoints live at
  // /api/payments/razorpay/{config,order,verify}.
  RAZORPAY_UI: true,
};

export const isEnabled = (key) => Boolean(FEATURES[key]);

// True when ANY payment gateway UI should be exposed (drives menu/CTAs).
export const PAYMENTS_UI_ENABLED = () =>
  isEnabled("STRIPE_UI") || isEnabled("RAZORPAY_UI");
